import { render, staticRenderFns } from "./Popular_proMobile.vue?vue&type=template&id=3cd23444&"
import script from "./Popular_proMobile.vue?vue&type=script&lang=js&"
export * from "./Popular_proMobile.vue?vue&type=script&lang=js&"
import style0 from "./Popular_proMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports